module.exports = __webpack_public_path__ + "img/loading-indicator.b0c38ec1.svg";